import React from 'react';

interface IconProps {
  size?: number;
  strokeWidth?: number;
  stroke?: string;
  className?: string;
}

const Svg = ({
  size = 20,
  strokeWidth = 2,
  stroke = 'currentColor',
  className,
  children,
}: IconProps & { children: React.ReactNode }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={className}
  >
    {children}
  </svg>
);

export const WeatherIcon = (p: IconProps) => (
  <Svg strokeWidth={1.8} {...p}>
    <path d="M12 3v2M5.6 5.6l1.4 1.4M3 12h2M17 12a5 5 0 1 0-9.6 2" />
    <path d="M7 19h11a3 3 0 0 0 0-6h-.5" />
  </Svg>
);

export const PinIcon = (p: IconProps) => (
  <Svg strokeWidth={1.8} {...p}>
    <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z" />
    <circle cx="12" cy="9.5" r="2.5" />
  </Svg>
);

export const LogoutIcon = (p: IconProps) => (
  <Svg size={18} strokeWidth={1.8} {...p}>
    <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 16l-4-4 4-4M6 12h10" />
  </Svg>
);

export const EyeIcon = (p: IconProps) => (
  <Svg strokeWidth={1.8} {...p}>
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);

export const EyeOffIcon = (p: IconProps) => (
  <Svg strokeWidth={1.8} {...p}>
    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
    <path d="M4 4l16 16" />
  </Svg>
);

export const LockIcon = (p: IconProps) => (
  <Svg size={14} {...p}>
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </Svg>
);

export const AlertIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5v5.5M12 16.5h.01" />
  </Svg>
);

export const InfoIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 8h.01" />
  </Svg>
);

export const SearchIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-4-4" />
  </Svg>
);

export const ChevronRightIcon = (p: IconProps) => (
  <Svg size={14} strokeWidth={2.2} {...p}>
    <path d="M9 6l6 6-6 6" />
  </Svg>
);

export const ChevronLeftIcon = (p: IconProps) => (
  <Svg size={16} strokeWidth={2.2} {...p}>
    <path d="M15 6l-6 6 6 6" />
  </Svg>
);

export const ArrowRightIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Svg>
);

export const DownloadIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <path d="M12 4v11M7 10l5 5 5-5M5 20h14" />
  </Svg>
);

export const PlusIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <path d="M12 5v14M5 12h14" />
  </Svg>
);

export const MinusIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <path d="M5 12h14" />
  </Svg>
);

export const FitIcon = (p: IconProps) => (
  <Svg size={18} {...p}>
    <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
  </Svg>
);

export const ChevronDownIcon = (p: IconProps) => (
  <Svg size={16} {...p}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);

export const CalendarIcon = (p: IconProps) => (
  <Svg size={18} strokeWidth={1.8} {...p}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
    <path d="M3.5 10h17M8 3v4M16 3v4" />
  </Svg>
);

export const CalendarOffIcon = (p: IconProps) => (
  <Svg size={40} strokeWidth={1.6} {...p}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
    <path d="M3.5 10h17M8 3v4M16 3v4M10 14l4 4M14 14l-4 4" />
  </Svg>
);
